import { render, staticRenderFns } from "./ProjectPOABudgetRequests.vue?vue&type=template&id=18cdfe5e"
import script from "./ProjectPOABudgetRequests.vue?vue&type=script&lang=js"
export * from "./ProjectPOABudgetRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports